import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        user_permissions: [],
        fiduciary: {},
        user: {},
        companies: [],
        logo: null,
        company: {},
        companies_loaded: false,
        fiscal_years: [],
        current_fiscal_year: {},
        should_filter_per_fiscal_year: null,
        new_company_id: null,
        new_company_name: null,
        standard_ledger_id: null,
        standard_ledgers: null,
        background: null,
        items: [],
        accounts: {},
        redirect_url: null,
        activate_add_bank_button: false,
        account: {},
        third_color: null,
        vat_rates: [],
        units: [],
        current_invoicing_client: null,
        new_or_modify: null,
    },
    mutations: {
        SET_THIRD_COLOR(state, payload) {
            state.third_color = payload;
        },
        SET_ACCOUNT(state, payload) {
            state.account = payload;
        },
        SET_REDIRECTED_URL(state, payload) {
            state.redirect_url = payload;
            state.activate_add_bank_button = true;
        },
        SET_ITEMS(state, payload) {
            state.items = payload;
        },
        SET_ACCOUNTS(state, payload) {
            state.accounts[payload["item_id"]] = payload["accounts"];
        },
        SET_SHOULD_FILTER_PER_FISCAL_YEAR(state, payload) {
            state.should_filter_per_fiscal_year = payload;
        },
        SET_USER_PERMISSIONS(state, payload) {
            state.user_permissions = payload;
        },
        SET_COMPANY(state, payload) {
            state.company = payload;
        },
        SET_STANDARD_LEDGERS(state, payload) {
            state.standard_ledgers = payload;
        },
        SET_LOGO(state, payload) {
            state.logo = payload;
        },
        SET_FIDUCIARY(state, payload) {
            state.fiduciary = payload;
        },
        SET_USER(state, payload) {
            state.user = payload;
        },
        SET_COMPANIES(state, payload) {
            state.companies_loaded = true;
            state.companies = payload;
        },
        SET_FISCAL_YEARS(state, payload) {
            state.fiscal_years = payload;
        },
        SET_CURRENT_FISCAL_YEAR(state, payload) {
            state.current_fiscal_year = payload;
        },
        SET_STANDARD_LEDGER_ID(state, payload) {
            state.standard_ledger_id = payload;
        },
        SET_BACKGROUND(state, payload) {
            state.background = payload;
        },
        SET_VAT_RATES(state, payload) {
            state.vat_rates = payload;
        },
        SET_UNITS(state, payload) {
            state.units = payload;
        },
        SET_CURRENT_INVOICING_CLIENT(state, payload) {
            state.current_invoicing_client = payload;
        },
        SET_IF_NEW_OR_MODIFY_CLIENT(state, payload) {
            state.new_or_modify = payload;
        },
    },
    actions: {
        get_fiduciary({ commit }) {
            return axios.get("/users/get_fiduciary").then((response) => {
                let client_data = response.data;
                store.commit("SET_BACKGROUND", client_data.background);
                store.commit(
                    "SET_USER_PERMISSIONS",
                    client_data.user_permissions
                );
                store.commit("SET_LOGO", client_data.logo);
                store.commit("SET_USER", client_data.user);
                store.commit("SET_FIDUCIARY", client_data.fiduciary);
            });
        },
        get_companies({ commit }) {
            return axios.get("/users/companies_for_user").then((response) => {
                commit("SET_COMPANIES", response.data);
            });
        },
        get_company({ commit }, payload) {
            return axios
                .get(
                    `/fiduciaries/${payload.fiduciary_id}/companies/${payload.company_id}/company_for_user`
                )
                .then((response) => {
                    let company = response.data["company"];
                    let fiscal_years = response.data["fiscal_years"];
                    let standard_ledgers = response.data["standard_ledgers"];
                    fiscal_years = fiscal_years.sort((a, b) => {
                        let date1 = new Date(a.begin_exercise);
                        let date2 = new Date(b.begin_exercise);
                        return date1 - date2;
                    });
                    commit("SET_COMPANY", company);
                    commit("SET_FISCAL_YEARS", fiscal_years);
                    commit("SET_STANDARD_LEDGERS", standard_ledgers);
                });
        },
        get_items({ commit }, payload) {
            return axios
                .post(
                    `/fiduciaries/${payload.fiduciary_id}/companies/${payload.company_id}/bank_items/list`
                )
                .then((response) => {
                    let items = response.data["bankin_data"];
                    commit("SET_ITEMS", items);
                    let x = items.map((item) =>
                        store.dispatch("get_accounts", {
                            fiduciary_id: payload.fiduciary_id,
                            company_id: payload.company_id,
                            item_id: item.id,
                        })
                    );
                    return Promise.all(x);
                });
        },
        get_accounts({ commit }, payload) {
            return axios
                .post(
                    `/fiduciaries/${payload.fiduciary_id}/companies/${payload.company_id}/bank_items/${payload.item_id}/list_accounts`
                )
                .then((response) => {
                    commit("SET_ACCOUNTS", {
                        item_id: payload.item_id,
                        accounts: response.data["list_accounts"],
                    });
                });
        },
        get_account({ commit }, payload) {
            return axios
                .get(
                    `/fiduciaries/${payload.fiduciary_id}/companies/${payload.company_id}/bank_items/${payload.item_id}/bank_accounts/${payload.account_id}/account`
                )
                .then((response) => {
                    commit("SET_ACCOUNT", response.data["account"]);
                });
        },
        get_redirected_url({ commit }, payload) {
            return axios
                .get(
                    `/fiduciaries/${payload.fiduciary_id}/companies/${payload.company_id}/redirected_url`
                )
                .then((response) => {
                    commit(
                        "SET_REDIRECTED_URL",
                        response.data["redirected_url"]
                    );
                });
        },
        get_units({ commit }, payload) {
            return axios
                .get(`/invoicing_products/get_units`, {
                    params: payload,
                })
                .then((response) => {
                    store.commit("SET_UNITS", response.data.units);
                });
        },
        get_vat_rates({ commit }, payload) {
            return axios
                .get(`/vat_rates/get_vat_rates`, {
                    params: payload,
                })
                .then((response) => {
                    store.commit("SET_VAT_RATES", response.data.vat_rates);
                });
        },
    },
});

export default store;
